import { Sparkles, User, Swords } from "lucide-react";
import { Card, CardContent } from "../ui/Card";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/Button";
import { motion } from "framer-motion";

export default function MathTrainerHome() {
    const navigate = useNavigate();
    const goToMath = () => navigate("/math");

    return (
        <>
            {/* Hero Section */}
            <main className="flex flex-col items-center justify-center text-center p-8">
                <motion.h2
                    className="text-5xl font-extrabold mb-6"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    Sharpen Your Math Skills!
                </motion.h2>
                <motion.p
                    className="text-lg max-w-2xl mb-10"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                >
                    Compete with friends, track your progress, and become a math master!
                    Choose your training mode and start practicing today.
                </motion.p>
                <div className="flex gap-4">
                    <Button size="lg"
                            className="text-lg px-8 py-4 bg-green-500 hover:bg-green-600"
                            onClick={goToMath}>
                        Start Math
                    </Button>
                    <Button size="lg" variant="secondary" className="text-lg px-8 py-4">
                        View Leaderboard
                    </Button>
                </div>
            </main>

            {/* Cards Section */}
            <section className="grid grid-cols-1 md:grid-cols-3 gap-6 p-8 w-full max-w-6xl">
                {[
                    { title: "Daily Challenges", color: "bg-pink-400", icon: <Swords /> },
                    { title: "Achievements", color: "bg-yellow-400", icon: <Sparkles /> },
                    { title: "Profile Settings", color: "bg-blue-400", icon: <User /> }
                ].map((item, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.2 }}
                    >
                        <Card className={`rounded-2xl shadow-lg hover:scale-105 transition-transform duration-300 ${item.color}`}>
                            <CardContent className="flex flex-col items-center justify-center h-48 text-white">
                                <div className="mb-4">{item.icon}</div>
                                <h3 className="text-xl font-semibold">{item.title}</h3>
                            </CardContent>
                        </Card>
                    </motion.div>
                ))}
            </section>
        </>
    );
}
